import { Box } from "@mui/material";
import * as styles from "./hsvDividerStyles";

interface HsvDividerProps {
    children?: React.ReactNode;
}

const HsvDivider: React.FC<HsvDividerProps> = ({ children }) => {
    return (
        <Box sx={styles.hsvDividerContainer}>
            <Box sx={styles.hsvDividerLine} />
            <Box sx={styles.dividerContent}>{children}</Box>
            <Box sx={styles.hsvDividerLine} />
        </Box>
    );
};

export default HsvDivider;
